<template>
  <a-spin class="spin-box" v-if="loading" />
  <a-empty class="spin-box" description="未找到此类型平台" v-else-if="!loading && !platformType" />
  <div ref="login" class="login lessonplay-shell" :class="{ 'column': pageContent.template == 'column' }"
    :style="{ backgroundImage: 'url(' + pageContent.background_image + ')' }"
    v-else-if="!loading && platformType && pageContent">
    <img class="login-title" :src="pageContent.title_image" />
    <div class="login-content" :class="{ 'white': pageContent.login_box_color == '#ffffff' }"
      :style="{ background: pageContent.login_box_color, boxShadow: `0 0 14px ${pageContent.theme_color}` }">
      <!-- 账号密码登录 -->
      <div class="login-box accont-box" v-if="!openRegister && !openForget">
        <div class="wx-text">帐号登录</div>
        <div class="input-box">
          <a-input class="accont-input" size="large" v-model="account" placeholder="请输入帐号" />
          <a-input-password class="password-input" size="large" v-model="password" placeholder="请输入密码"
            @keyup.enter="login()" autocomplete="“off”" />
        </div>
        <div class="login-button-box">
          <a-button class="login-button" size="large" type="primary" @click="login()" :loading="logining"
            :style="{ background: pageContent.theme_color }">登录</a-button>
          <div class="skip">
            <div @click="openRegister = true">注册账号</div>
            <div @click="openForget = true">忘记密码</div>
          </div>
        </div>
      </div>
      <!-- 帐号注册 -->
      <div class="login-box register-box" v-if="openRegister">
        <div class="wx-text">帐号注册</div>
        <div class="input-box">
          <form action>
            <a-input class="input-item" size="large" :maxLength="11" v-model="formRegister.phone"
              placeholder="请输入手机号作为账号" />
            <a-input-password class="input-item password-input" size="large" v-model="formRegister.password"
              placeholder="请输入密码(不小于6位)" :maxLength="20" autocomplete="“off”" />
            <a-input-password class="input-item password-input" size="large" v-model="formRegister.checkPassword"
              placeholder="请再次输入密码" :maxLength="20" autocomplete="“off”" />
            <a-input class="input-item " size="large" :maxLength="20" v-model="formRegister.nickName"
              placeholder="请输入真实的姓名" />
          </form>
        </div>
        <div class="login-button-box">
          <a-button class="login-button" size="large" type="primary" @click="register" :loading="registering"
            :style="{ background: pageContent.theme_color }">确认注册</a-button>
          <div class="return-login" @click="returnLogin">返回</div>
        </div>
      </div>
      <!-- 找回密码 -->
      <div class="login-box register-box" v-if="openForget">
        <div class="wx-text">找回密码</div>

        <template v-if="forgetStep == 1">
          <div class="input-box">
            <a-input v-model="formRegister.phone" class="input-item" size="large" placeholder=" 请输入手机号" />
            <div class="pass-box">
              <a-input v-model="formRegister.code" class="input-item" size="large" placeholder="请输入验证码" suffix />
              <span class="get-pass" v-if="codeShow" @click="getPhoneCode">获取验证码</span>
              <span class="get-pass" v-if="!codeShow">{{ count }}秒后重试</span>
            </div>
          </div>
          <div class="login-button-box">
            <a-button type="primary" html-type="submit" class="login-button" :loading="registering"
              :style="{ background: pageContent.theme_color }" @click="checkForget">下一步</a-button>
            <div class="return-login" @click="forgetStep = 1; openForget = false;">返回</div>
          </div>
        </template>

        <!-- 确认新密码 -->
        <template v-if="forgetStep == 2">
          <div class="input-box">
            <a-input-password class="input-item password-input" size="large" v-model="newPass.newpw"
              placeholder="请输入新密码" />
            <a-input-password class="input-item password-input" size="large" v-model="newPass.confirmpw"
              placeholder="请再次输入新密码" />
          </div>
          <div class="login-button-box">
            <a-button type="primary" html-type="submit" class="login-button" :loading="editPasswording"
              :style="{ background: pageContent.theme_color }" @click="editPassword">确认</a-button>
            <div class="return-login" @click="forgetStep = 1; openForget = false;">返回</div>
          </div>
        </template>
      </div>
      <!-- 扫码登录 -->
      <div class="login-box wx-box" :class="{ hidden: openRegister || openForget }">
        <div class="wx-text">扫码登录</div>
        <div id="wx-login-qrCode"></div>
      </div>
    </div>
    <img class="bottom-logo" :src="pageContent.info_image" v-if="pageContent.info_image" />
  </div>
</template>

<script>
import { PASSPORT_SERVER } from '@/config/url';
import { PC_APPID, SCOPE } from '@/config/wx';
import { addQueryString } from '@/util/url';

export default {
  name: "login",
  data() {
    return {
      formRegister: {
        phone: '',
        password: '',
        checkPassword: '',
        nickName: '',
      },

      loading: true,
      logining: false,
      openRegister: false,
      registering: false,


      account: '',
      password: '',
      redirectURI: '',
      platformType: '',

      forgetStep: 1,
      count: 60,
      codeId: '',
      codeShow: true,

      pageContent: null,

      openForget: false,
      editPasswording: false,
      newPass: {
        userGuid: '',
        newpw: '',
        confirmpw: ''
      }
    }
  },
  async mounted() {
    this.getPlatformInfo();
  },
  methods: {
    //获取平台信息
    async getPlatformInfo() {
      let { type } = this.$route.params;
      if (!type) {
        this.$message.error("不存在此类型平台");
        return this.loading = false;
      }

      let res = await this.$api.unifydata.getPlatformInfo(type);
      if (res.statusCode != 200) {
        this.loading = false
        return this.$message.error(res.message);
      }

      let platform = res.data;
      const search = new URLSearchParams(location.search)
      this.redirectURI = search.get('redirectURI') || platform.Url;
      //验证本地token
      const verifyRet = await this.$api.passport.verifyToken();
      if (verifyRet.status === 1) location.href = addQueryString(this.redirectURI, 'token', verifyRet.token);

      let { pageConfig } = platform;
      if (!pageConfig || !pageConfig.page_list || pageConfig.page_list.length == 0) return this.loading = false;
      let page = pageConfig.page_list.find(item => item.type == 'login');
      if (!page) return this.loading = false;

      let pageContent = { theme_color: pageConfig.theme_color };
      page.content.forEach(item => { pageContent[item.type] = item.value });
      this.pageContent = pageContent;

      this.platformType = type;
      if (pageConfig.logo) this.changeFavicon(pageConfig.logo);
      this.loading = false;
      setTimeout(() => {
        this.wxloginForPC()
        if (this.isDark(pageConfig.theme_color)) this.$refs.login.classList.add('dark-theme');
      }, 100);
    },
    //生成登录二维码
    wxloginForPC() {
      const wxApiRedirectURI = `${PASSPORT_SERVER}/wx/client_strict?redirectURI=${this.redirectURI}`;
      let href = `https://cdn.lessonplan.cn/Public/CSS/wx-login-style(white).css`;
      let { login_box_color } = this.pageContent;
      if (login_box_color == '#ffffff') href = `https://cdn.lessonplan.cn/Public/CSS/wx-login-style.css`;
      //eslint-disable-next-line
      new WxLogin({
        id: 'wx-login-qrCode',
        appid: PC_APPID,
        scope: SCOPE,
        redirect_uri: (wxApiRedirectURI),
        href: href,
        fast_login: 1,
      })
    },
    //账号密码登录
    async login() {
      let msg = '';
      if (!this.account || !this.password) msg = '请输入正确的账号密码';
      if (msg) return this.$message.warning(msg);

      this.logining = true;
      //登录
      let res = await this.$api.passport.auth({ username: this.account, password: this.password });
      if (res.status != 1) {
        this.logining = false;
        return this.$message.warning('用户名或密码不正确');
      }
      this.$message.success('登陆成功');
      location.href = addQueryString(this.redirectURI, 'token', res.token);
    },
    //确定注册
    async register() {
      let registering = this.registering;
      if (registering) return;
      let { phone, password, checkPassword, nickName } = this.formRegister;
      let msg = '';

      if (!/^1[3456789]\d{9}$/.test(phone)) msg = '请输入正确的手机号';
      else if (!password || password.length < 6) msg = '密码不符合规则，请输入6位以上密码';
      else if (checkPassword != password) msg = '两次输入的密码不一致';
      else if (!nickName) msg = '请输入姓名';
      if (msg) return this.$message.warning(msg);

      nickName = nickName.trim();
      registering = true;
      let res = await this.$api.account.register({ Name: phone, Phone: phone, Password: password, NickName: nickName });
      registering = false;
      if (res.status != 1) return this.$message.error(res.err);

      this.$message.success('注册成功');
      this.returnLogin();
    },
    //返回登录
    async returnLogin() {
      this.openRegister = false;
      this.formRegister = {
        phone: '',
        pass: '',
        checkPass: ''
      }
    },
    async getPhoneCode() {
      let { phone } = this.formRegister;
      if (!/^1[3456789]\d{9}$/.test(phone)) return this.$message.warning('请输入正确的手机号');

      this.codeShow = false;
      this.count = 60;
      let countTime = setInterval(() => {
        if (this.count <= 0) {
          clearInterval(countTime);
          this.codeShow = true;
          return;
        }
        this.count--;
      }, 1000);

      this.$message.success('短信已发送，请注意查收');

      let res = await this.$api.account.sendSms(phone);
      if (res.code != 1) return this.$message.error(res.msg);
      this.codeId = res.data.PK_CodeGuid;
    },
    //验证忘记密码
    async checkForget() {
      if (this.registering) return;
      const { phone, code } = this.formRegister;

      let msg = '';
      if (!/^1[3456789]\d{9}$/.test(phone)) msg = '请输入正确的手机号';
      else if (!code) msg = '请输入验证码';
      if (msg) return this.$message.warning(msg);

      this.registering = true;
      let userList = await this.$api.account.getClientByUser(phone).then(res => res.data || []);
      if (userList.length == 0) {
        this.registering = false;
        return this.$message.warning("未找到该用户，请确认手机号是否正确");
      }
      this.newPass.userGuid = userList[0].PK_UserGuid;

      let res = await this.$api.account.checkcode(this.codeId, code);
      this.registering = false;

      this.codeId = '';
      this.formRegister.code = '';
      this.formRegister.phone = '';

      if (res.code != 1) return this.$message.error(res.message);
      this.forgetStep = 2;
    },
    //修改密码
    async editPassword() {
      if (this.editPasswording) return;
      const newPass = this.newPass;

      let msg = '';
      for (const key in newPass) {
        if (newPass[key] && typeof (newPass[key]) === 'string') newPass[key] = newPass[key].trim();
      }
      if (!newPass.newpw) msg = '请输入新密码';
      else if (newPass.newpw.length < 6) msg = '请至少输入6位密码';
      else if (!newPass.confirmpw) msg = '请再次输入新密码';
      else if (newPass.newpw != newPass.confirmpw) msg = '两次输入的密码不一致';

      if (msg) return this.$message.warning(msg);

      this.editPasswording = true;
      let res = await this.$api.account.setNewPassword({
        PK_UserGuid: newPass.userGuid,
        Password: newPass.newpw,
      });
      this.editPasswording = false;

      if (res.status != 1) return this.$message.error(res.message);

      this.$message.success('密码重置成功');
      this.forgetStep = 1;
      this.openForget = false;
    },

    //修改标签图标
    changeFavicon(link) {
      let $favicon = document.querySelector('link[rel="icon"]');
      if ($favicon !== null) {
        $favicon.href = link;
      } else {
        $favicon = document.createElement("link");
        $favicon.rel = "icon";
        $favicon.href = link;
        document.head.appendChild($favicon);
      }
    },
    //是否深色
    isDark(color) {
      const r = parseInt(color.slice(1, 3), 16);
      const g = parseInt(color.slice(3, 5), 16);
      const b = parseInt(color.slice(5, 7), 16);
      const luminance = (0.2126 * r + 0.7152 * g + 0.0722 * b);
      return luminance < 128;
    },
  }
}
</script>

<style scoped lang="scss">
@import "./login.scss";
</style>